import type { ReactNode } from "react";
import { Tick02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

const RecommendedBadge = () => (
  <Badge
    variant={BadgeVariant.SUCCESS}
    size={BadgeSize.SM}
    className="flex-none items-center"
    leftElement={
      <HugeiconsIcon icon={Tick02Icon} size={12} strokeWidth={2.5} />
    }
  >
    Recommended
  </Badge>
);

export const RecommendedTitle = ({ title }: { title: ReactNode }) => (
  <span className="flex min-w-0 items-center gap-2">
    <span className="min-w-0 truncate">{title}</span>
    <RecommendedBadge />
  </span>
);

export const RecommendationReason = ({ reason }: { reason: string }) => (
  <span className="block truncate text-xs font-medium text-content-400">
    {reason}
  </span>
);
